import React, { createContext, useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import userApi from '_api/user'
import { SelectIdGroupContext } from '_context/SelectGroupContext'

export const ConsolidatedContext = createContext()

export default function ConsolidatedProvider({ children }) {
  const { infoGroupSelected } = useContext(SelectIdGroupContext)
  const { groupId } = infoGroupSelected
  const [listRef, setListRef] = useState([])
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(true)

  const refreshConsolidated = async () => {
    if (!groupId) {
      setLoading(false)
      return
    }

    setLoading(true)
    try {
      const response = await userApi.getListConsolidated(groupId)
      const { msgResp } = response

      const sortedItems = (msgResp.items || []).sort(
        (a, b) => a.createdAt - b.createdAt
      )
      setListRef(sortedItems)
      setCount(msgResp.count || 0)
    } catch (error) {
      console.error('Failed to fetch consolidated data:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    refreshConsolidated()
  }, [groupId])

  const addConsolidated = (list) => {
    setListRef((prev) => [...prev, list])
    setCount((prev) => prev + 1)
  }

  const removeConsolidated = (id) => {
    setListRef((prev) => prev.filter((item) => item?.id !== id))
    setCount((prev) => Math.max(0, prev - 1))
  }

  const values = {
    listRef,
    count,
    loading,
    addConsolidated,
    removeConsolidated,
    refreshConsolidated,
  }

  return (
    <ConsolidatedContext.Provider value={values}>
      {children}
    </ConsolidatedContext.Provider>
  )
}

ConsolidatedProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
